import { Credentials } from '../../assets/features/Credentials';
import { generateConfirmationEmailHTML } from '../templates/ConfirmationEmailTemplate';
import { generateNotificationEmailHTML } from '../templates/NotificationEmailTemplate';

/**
 * Send confirmation email to user via Resend Cloud Function
 */
export const sendConfirmationEmail = async (userEmail, userName) => {
    try {
        // Validate Cloud Function URL
        if (!Credentials.EMAIL_CLOUD_FUNCTION_URL) {
            throw new Error('Email Cloud Function URL is not configured. Please set REACT_APP_EMAIL_CLOUD_FUNCTION_URL in your environment variables.');
        }

        const emailData = {
            sender: {
                name: "FielCarga",
                email: Credentials.EMAIL_SENDER_EMAIL
            },
            to: {
                email: userEmail,
                name: userName
            },
            subject: "Confirmação de Pedido - FielCarga",
            htmlContent: generateConfirmationEmailHTML(userName)
        };

        const fetchOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(emailData)
        };
        let response;
        try {
            response = await fetch(Credentials.EMAIL_CLOUD_FUNCTION_URL, { ...fetchOptions, keepalive: true });
        } catch (err) {
            console.warn('keepalive fetch failed, retrying without keepalive:', err && err.message);
            response = await fetch(Credentials.EMAIL_CLOUD_FUNCTION_URL, fetchOptions);
        }

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
            const errorMessage = errorData.error || errorData.message || `HTTP error! status: ${response.status}`;
            throw new Error(errorMessage);
        }

        const result = await response.json();
        return { success: true, messageId: result.messageId };
    } catch (error) {
        console.error('Error sending confirmation email:', error);
        throw error;
    }
};

/**
 * Send notification email to company via Resend Cloud Function
 */
export const sendNotificationEmail = async (formData) => {
    try {
        // Validate Cloud Function URL
        if (!Credentials.EMAIL_CLOUD_FUNCTION_URL) {
            throw new Error('Email Cloud Function URL is not configured. Please set REACT_APP_EMAIL_CLOUD_FUNCTION_URL in your environment variables.');
        }

        const emailData = {
            sender: {
                name: "FielCarga - Sistema de Contacto",
                email: Credentials.EMAIL_SENDER_EMAIL
            },
            to: {
                email: Credentials.EMAIL_RECEIVER_EMAIL,
                name: "FielCarga"
            },
            replyTo: {
                email: formData.email,
                name: formData.name
            },
            subject: `Novo Pedido de Contacto - ${formData.name}`,
            htmlContent: generateNotificationEmailHTML(formData)
        };

        const fetchOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(emailData)
        };
        let response;
        try {
            response = await fetch(Credentials.EMAIL_CLOUD_FUNCTION_URL, { ...fetchOptions, keepalive: true });
        } catch (err) {
            console.warn('keepalive fetch failed, retrying without keepalive:', err && err.message);
            response = await fetch(Credentials.EMAIL_CLOUD_FUNCTION_URL, fetchOptions);
        }

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
            const errorMessage = errorData.error || errorData.message || `HTTP error! status: ${response.status}`;
            throw new Error(errorMessage);
        }

        const result = await response.json();
        return { success: true, messageId: result.messageId };
    } catch (error) {
        console.error('Error sending notification email:', error);
        throw error;
    }
};

/**
 * Send both emails (confirmation to user and notification to company)
 */
export const sendContactFormEmails = async (formData) => {
    try {
        // Send both emails in parallel
        const [confirmationResult, notificationResult] = await Promise.all([
            sendConfirmationEmail(formData.email, formData.name),
            sendNotificationEmail(formData)
        ]);
        
        return {
            success: true,
            confirmation: confirmationResult,
            notification: notificationResult
        };
    } catch (error) {
        console.error('Error sending emails:', error);
        throw error;
    }
};
